import "./ComplementaryReports.css";
import DatePicker from "../../components/UI/DatePicker/DatePicker";
import Search from "../../components/UI/Search/Search";
import Button from "../../components/UI/Button/Button";
import FetchData from "../../shared/fetchData";
import { useState } from "react";
import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import moment from 'moment-jalaali'

const ReportThree = (props) => {
    const today = new Date()

    const [from, setFrom] = useState(moment(today).format('jYYYY/jMM/jDD'))
    const [to, setTo] = useState(moment(today).format('jYYYY/jMM/jDD'))
    const [loading, setLoading] = useState('')


    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getComplementaryReports3'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.complementaryOrders.map(o => {
                        count++
                        exportOrderReport.push({
                            'نام ایستگاه یا محل استقرار': o.kioskAddress,
                            'تعداد سفارش یا رزرو': o.count,
                            "شماره باکس": o.lockerSerial,
                            "شماره لاکر": o.kioskDescription,
                            "تاریخ و ساعت رزرو": o.registerDate,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'report3' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const refresh = (event) => {
        setFrom('')
        setTo('')
    }
    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }

    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const form = <>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-3 small-date-col">
                <DatePicker change={changeFromDate} value={from} placeHolder="تاریخ ثبت سفارش از" />
            </div>
            <div className="col-3 small-date-col">
                <DatePicker change={changeToDate} value={to} placeHolder="تاریخ ثبت سفارش تا" />
            </div>
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </>
    return (
        <>
            <Search class="cmplmnt-Search" form={form} />
            <div>

            </div>
        </>
    )
}

export default ReportThree;